// removed by extract-text-webpack-plugin
module.exports = {"box":"src-layouts----RightBox-module---box---2vN20","small_screen_drop":"src-layouts----RightBox-module---small_screen_drop---3OOjN"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/RightBox.module.css
// module id = 615
// module chunks = 114276838955818